import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';

var _excluded = ["ariaLabel", "icon", "classList", "isDisabled", "onClick", "labelText", "theme", "type", "variant"];
var propTypes = {
  /** Name of the icon to display (must match the icon font or sprite name) */
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  /** Accessible label for the button (required for accessibility if no visible text) */
  ariaLabel: PropTypes.string,
  /** Additional CSS classes to apply to the button */
  classList: PropTypes.string,
  /** If true, disables the button */
  isDisabled: PropTypes.bool,
  /** Alternative accessible label (used if ariaLabel prop is not provided) */
  labelText: PropTypes.string,
  /** Visual theme for the button */
  theme: PropTypes.oneOf(['', 'inverse', 'translucent']),
  /** [Button type attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type) */
  type: PropTypes.string,
  /** Visual variant for the button shape */
  variant: PropTypes.oneOf(['', 'square'])
};
function IconButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
    icon = _ref.icon,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClick = _ref.onClick,
    labelText = _ref.labelText,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? null : _ref$theme,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? null : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("button", _extends({
    "aria-label": ariaLabel || labelText,
    className: "icon-button ".concat(classList),
    "data-theme": theme,
    "data-variant": variant,
    disabled: isDisabled,
    onClick: onClick,
    type: type
  }, props), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    "data-icon": icon,
    "data-testid": "icon-button-icon"
  }));
}
IconButton.propTypes = propTypes;

export { IconButton as default };
//# sourceMappingURL=IconButton.js.map
